import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Alert, Button, Card } from "flowbite-react";
import Input from "../inputs/Input";
import SelectInput from "../inputs/SelectInput";
import CPFInput from "../inputs/CPFInput";
import AutoCompleteInput from "../inputs/Autocomplete";
import ComunicateSellSection from "./ComunicateSellSection";
import * as yup from "yup";
import { SURVEYS, USERS } from "../../config/apiConfig";
import axios from "../../config/axiosInstance";
import { useQuery } from "react-query";
import { useEffect, useState } from "react";
import CNPJInput from "../inputs/CNPJInput";
import useCEP from "../../hooks/useCEP";
import PhoneInput from "../inputs/PhoneInput";
import { isValidCNPJ, isValidCPF } from "../../utils/utils";

const schema = yup.object().shape({
  nomeVendedor: yup.string().required("O nome é obrigatório"),
  cpfCnpjVendedor: yup
    .string()
    .required("O documento é obrigatório")
    .test("cpfCnpj", "Documento inválido", function (value) {
      if (!value) return false;
      const documento = value.replace(/\D/g, "");

      if (documento.length === 11) {
        return isValidCPF(documento);
      } else if (documento.length === 14) {
        return isValidCNPJ(documento);
      }
      return false;
    }),
});

const SellerData = ({
  setActiveStep,
  communicateSell,
  setCommunicateSell,
  states,
  isSubmitting,
}) => {
  const [error, setError] = useState(null);
  const [municipios, setMunicipios] = useState([]);
  const [isLoadingMunicipios, setIsLoadingMunicipios] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const {
    cep,
    setCep,
    address,
    loading: loadingCEP,
    error: errorCEP,
  } = useCEP();

  const onBlurSearchCEP = (e) => {
    setCep(getValues("cepVendedor"));
  };

  useEffect(() => {
    setValue("logradouroVendedor", address?.logradouro);
    setValue("bairroVendedor", address?.bairro);
    setValue("codigoMunicipioVendedor", address?.localidade);
  }, [address]);

  useEffect(() => {
    if (communicateSell) {
      Object.entries(communicateSell).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          setValue(key, value);
        }
      });
    }
  }, [communicateSell, setValue]);

  useEffect(() => {
    setIsLoadingMunicipios(true);
    const getMunicipios = async () => {
      const response = await axios.get(
        `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${watch(
          "ufVendedor"
        )}/municipios?orderBy=nome`
      );

      setMunicipios(
        response?.data?.map((municipio) => ({
          value: municipio.id,
          label: municipio.nome,
        }))
      );
      setIsLoadingMunicipios(false);
    };

    getMunicipios();
  }, [watch("ufVendedor")]);

  const onBack = async () => {
    setActiveStep(2);
  };

  const onSubmit = async (data) => {
    setCommunicateSell((prev) => ({ ...prev, ...data }));

    setActiveStep(4);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <ComunicateSellSection name="Dados do vendedor">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <SelectInput
              register={register}
              name="codigoTipoPessoaVendedor"
              label="Tipo de pessoa"
            >
              <option value={0}>Pessoa Física</option>
              <option value={1}>Pessoa Jurídica</option>
            </SelectInput>
            {errors.codigoTipoPessoaVendedor?.message && (
              <small className="text-red-600">
                {errors.codigoTipoPessoaVendedor?.message}
              </small>
            )}
          </div>
          <div>
            <Input
              register={register}
              name="nomeVendedor"
              label="Nome do vendedor *"
              required={true}
              uppercase
            />
            {errors.nomeVendedor?.message && (
              <small className="text-red-600">
                {errors.nomeVendedor?.message}
              </small>
            )}
          </div>

          <div>
            {watch("codigoTipoPessoaVendedor") == 0 ? (
              <CPFInput
                register={register}
                name="cpfCnpjVendedor"
                label="CPF do vendedor *"
                required={true}
              />
            ) : (
              <CNPJInput
                register={register}
                name="cpfCnpjVendedor"
                label="CNPJ do vendedor *"
                required={true}
              />
            )}

            {errors.cpfCnpjVendedor?.message && (
              <small className="text-red-600">
                {errors.cpfCnpjVendedor?.message}
              </small>
            )}
          </div>
          <div>
            <PhoneInput
              register={register}
              name="telefoneVendedor"
              label="Telefone do vendedor"
              mask="CUSTOM"
            />
            {errors.telefoneVendedor?.message && (
              <small className="text-red-600">
                {errors.telefoneVendedor?.message}
              </small>
            )}
          </div>
        </div>
      </ComunicateSellSection>

      {/* <ComunicateSellSection name="Endereço do vendedor">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Input
              register={register}
              name="cepVendedor"
              label="CEP"
              onBlur={onBlurSearchCEP}
            />
            {errors.cepVendedor?.message && (
              <small className="text-red-600">
                {errors.cepVendedor?.message}
              </small>
            )}
          </div>

          <div>
            <Input
              register={register}
              name="logradouroVendedor"
              label="Endereço"
            />
            {errors.logradouroVendedor?.message && (
              <small className="text-red-600">
                {errors.logradouroVendedor?.message}
              </small>
            )}
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
          <div>
            <Input
              register={register}
              name="bairroVendedor"
              label="Bairro *"
              required={true}
            />
            {errors.bairroVendedor?.message && (
              <small className="text-red-600">
                {errors.bairroVendedor?.message}
              </small>
            )}
          </div>

          <div>
            <Input
              register={register}
              name="numeroEnderecoVendedor"
              label="Número *"
              required={true}
            />
            {errors.numeroEnderecoVendedor?.message && (
              <small className="text-red-600">
                {errors.numeroEnderecoVendedor?.message}
              </small>
            )}
          </div>

          <div>
            <Input
              register={register}
              name="complementoVendedor"
              label="Complemento"
            />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          <div>
            <AutoCompleteInput
              register={register}
              name="ufVendedor"
              label="UF do vendedor *"
              options={states}
              value={watch("ufVendedor")}
              onChange={(user) => setValue("ufVendedor", user.value)}
              required={true}
            />
            {errors.ufVendedor?.message && (
              <small className="text-red-600">
                {errors.ufVendedor?.message}
              </small>
            )}
          </div>
          <div>
            <AutoCompleteInput
              register={register}
              name="codigoMunicipioVendedor"
              label="Município do vendedor *"
              options={municipios}
              value={watch("codigoMunicipioVendedor")}
              onChange={(user) =>
                setValue("codigoMunicipioVendedor", user.value)
              }
              required={true}
              isLoading={isLoadingMunicipios}
            />
            {errors.codigoMunicipioVendedor?.message && (
              <small className="text-red-600">
                {errors.codigoMunicipioVendedor?.message}
              </small>
            )}
          </div>
        </div>
      </ComunicateSellSection> */}

      <div className="flex justify-center items-center gap-2 mt-10">
        <Button
          className="bg-gray-500"
          onClick={onBack}
          style={{ minWidth: "90px" }}
        >
          Voltar
        </Button>
        <Button
          type="submit"
          className="primary"
          disabled={isSubmitting}
          isProcessing={isSubmitting}
        >
          {!isSubmitting ? "Próximo" : "Salvando..."}
        </Button>
      </div>
      {error && (
        <Alert color="failure" withBorderAccent className="mt-4">
          Erro ao tentar salvar o laudo! Tente novamente mais tarde.
        </Alert>
      )}
    </form>
  );
};

export default SellerData;
